import Intercom from "@intercom/messenger-js-sdk";
import config, { IConfig } from "../../config";
import { IUserProps } from "../../redux/modules/auth/utils";

class IntercomFacade {
  private readonly config: IConfig["intercom"];
  constructor(config: IConfig["intercom"]) {
    this.config = config;
  }

  public initIntercom(user: IUserProps, appId: string, userHash: string) {
    if (!this.config.enabled) {
      return;
    }

    Intercom({
      app_id: appId,
      user_hash: userHash,
      name: user.name,
      email: user.email,
      vertical_padding: 60,
      hide_default_launcher: this.config.hideLauncher,
      language_override: "en",
      // custom attributes
      // those need to be added manually to intercom
      // see https://www.intercom.com/help/en/articles/179-create-and-track-custom-data-attributes-cdas
      app_name: "GCP App",
    });
  }
}

export const intercomSingleton = new IntercomFacade(config.intercom);
